import React, { Component } from 'react'
import { Button, Cascader, DatePicker, Icon, Input, InputNumber, Select, Tooltip, Upload, message } from 'antd';
import moment from 'moment';
import SearchRetrieve from '../../../common/SearchRetrieve.new'
import TableC from '../../../basicElement/TableC';
import RouteModal from './RouteModal';
import { xToken } from '../../../../common/AjaxRequest';
import SearchMulSelect from '../../../common/SearchMulSelect';
import SearchInput from '../../../common/SearchInput';
import MedicationSituation from './MedicationSituation';
import '../index.less';

const Option = Select.Option;
const { TextArea } = Input;

export default class FomeList extends Component {

    nodeRender = (config, isTable) => {
        const { params, handleChange, handleTableChange } = this.props;
        const {
            name,
            type,
            showName,
            disabled = false,
            typeProperty = {},
            index,
            tebleItemKey,
            tebleIDate,
            isYseOrNo,
            customizeProperty = []
        } = config;
        const {
            style = {},
            option = [],
            precision = 0,
            filterOption = false,
            showSearch = false,
            placeholder = '请选择',
            className = '',
        } = typeProperty;
        let Dom = '';
        const value = isTable ? tebleIDate : params[name];
        const domStyle = {
            width: '90%',
            ...style,
        };
        const key = isTable ? tebleItemKey : name;
        const handleNodeChange = (value, key, index) => {
            isTable ? 
                handleTableChange(value, key, index) :
                handleChange(value, key)
        }
        switch (type) {
            case 'Input':
                Dom = <Input 
                    style={domStyle}
                    value={value}
                    placeholder="请输入"
                    onChange={e => handleNodeChange(e.target.value, key, index)}
                />
                break;
            case 'InputNumber':
                Dom = <InputNumber 
                    style={domStyle}
                    className={className}
                    disabled={disabled}
                    value={value}
                    min={0}
                    precision={precision}
                    placeholder="请输入"
                    onChange={value => handleNodeChange(value, key, index)}
                />
                break;
            case 'TextArea':
                Dom = <TextArea 
                    style={domStyle}
                    value={value}
                    rows={4}
                    placeholder="请输入"
                    onChange={e => handleNodeChange(e.target.value, key, index)}
                />
                break;
            case 'Select':
                {
                    const options = option.map(el => (
                        <Option disabled={el.disabled} key={el.value} value={String(el.value)}>{el.label}</Option>
                    ));
                    const selectValue = (value !== undefined && value !== null) ? String(value) : undefined;
                    Dom = <Select 
                        style={domStyle}
                        showSearch={showSearch}
                        filterOption={filterOption}
                        value={selectValue}
                        placeholder={placeholder}
                        allowClear
                        onChange={value => handleNodeChange(value, key, index)}
                    >
                        {options}
                    </Select>
                    break;
                }
            case 'SearchInput':
                {
                    const value = params[name][index][showName];
                    Dom = <SearchInput
                            style={domStyle}
                            initValue={{ key: value, label: value }}
                            {...typeProperty}
                            handleSelect={value => handleNodeChange(value, key, index)}
                        />
                    break;
                }
            case 'SelectMultiple':
                {
                    const options = option.map(el => (
                        <Option disabled={el.disabled} key={el.value} value={String(el.value)}>{el.label}</Option>
                    ))
                    const value = type === 'Table' ? 
                        params[name][index][tebleItemKey] ? 
                            params[name][index][tebleItemKey].split(',') : []
                        : params[name] ? params[name].split(',') : [];
                    Dom = <Select 
                        style={domStyle}
                        value={value}
                        allowClear
                        disabled={disabled}
                        mode="multiple"
                        placeholder="请选择"
                        onChange={value => handleNodeChange(value.join(','), key, index)}
                    >
                        {options}
                    </Select>
                    break;
                }
            case 'SearchRetrieve':
                {
                    const value = type === 'Table' ? params[name][index][showName] : params[showName];
                    Dom = <SearchRetrieve
                        value={value}
                        {...typeProperty}
                        style={domStyle}
                        onChange={value => handleNodeChange(value, key, index)}
                    />
                    break;
                }
            case 'SearchMulSelect': {
                const value = type === 'Table' ? 
                        params[name][index][tebleItemKey] ? 
                            params[name][index][tebleItemKey].split(',') : []
                        : params[name] ? params[name].split(',') : [];
                const showNameArr = params[showName] ? params[showName].split('；') : [];
                const SelectValue = value.map((el, index) => {
                    return { key: el, label: showNameArr[index] }
                })
                Dom = <SearchMulSelect
                        value={SelectValue}
                        {...typeProperty}
                        style={domStyle}
                        placeholder='请输入检索'
                        handleSelect={value => handleNodeChange(value, key, index)}
                    />
                break;
            }
            case 'Cascader' :
                {
                    const value = type === 'Table' ? params[name][index][`${tebleItemKey}Value`] : params[`${name}Value`];
                    Dom = <Cascader 
                        options={option} 
                        placeholder="请选择"
                        style={domStyle}
                        allowClear
                        value={value}
                        onChange={value => handleNodeChange(value, key, index)}
                    />
                    break;
                }
                
            case 'DatePicker' :
                Dom = <DatePicker 
                    placeholder="请选择"
                    style={domStyle}
                    allowClear
                    value={value ? moment(value) : undefined}
                    onChange={(_, dateStr) => handleNodeChange(dateStr, key)}
                />
                break;
            case 'route' : //给药途径
                Dom = <span>{value} <a onClick={() => {
                    const medicationNumber = params[name][index].medicationNumber;
                    if(medicationNumber) {
                        this.RouteModalRef.show({
                            ...params[name][index],
                            index,
                        })
                    }else {
                        message.warning('请先选择药物数量')
                    }
                }}><Icon type="edit" /></a></span>
                break;
            case 'Upload': {
                Dom = <Upload
                        {...typeProperty}
                        headers={xToken}
                    >
                        {!typeProperty.disabled && <Button style={{ width: 80 }}>选择文件</Button>}
                    </Upload>
                break;
            }
            case 'customize': {
                Dom = <div style={{ display: 'flex' }}>
                    {customizeProperty.map((item, index) => {
                        const _domStyle = {
                            width: '90%',
                            ...item.style,
                        };
                        switch (item.type) {
                            case 'Cascader':
                                return <Cascader 
                                    options={item.option} 
                                    placeholder="请选择"
                                    style={_domStyle}
                                    allowClear={item.allowClear || false}
                                    value={params[item.name] || undefined}
                                    onChange={value => handleNodeChange(value, item.name, index)}
                                />
                            case 'Select':
                                const _options = item.option.map(el => (
                                    <Option disabled={el.disabled} key={el.value} value={String(el.value)}>{el.label}</Option>
                                ));
                                const selectValue = (params[item.name] !== undefined && params[item.name] !== null) ? String(params[item.name]) : undefined;
                                return <Select 
                                    style={_domStyle}
                                    showSearch={item.showSearch || false}
                                    filterOption={item.filterOption || false}
                                    value={selectValue}
                                    placeholder={item.placeholder || '请选择'}
                                    allowClear={item.allowClear || false}
                                    disabled={item.disabled || false}
                                    onChange={value => handleNodeChange(value, item.name, index)}
                                >
                                    {_options}
                                </Select>
                            case 'SearchRetrieve':
                                return <SearchRetrieve
                                        value={params[item.showName]}
                                        {...item}
                                        disabled={item.disabled || false}
                                        onChange={value => handleNodeChange(value, item.name, index)}
                                    />
                            default:
                                return null;
                        }
                    })}
                </div>
                break;
            }
            default:
                Dom = <span className='item-right_text'>{
                    isYseOrNo ? 
                        (value !== undefined && value !== null) ? 
                            value == '1' ? '是' : 
                                value == '0' ? '否' : 
                            value : 
                        value : 
                    value
                    }</span>
                break;
        }
        return Dom
    }

    refresh = (value, key) => {
        let processedValue = '';
        processedValue = (value || value == 0) ? value : undefined;
        this.props.handleChange(processedValue, key);
    }

    render() {
        const { DomConfig, params, updateType = 'view', handleTableChange, handleMedicationSituationChange, delTableRecord, style = {}, changeData = {} } = this.props;
        const asterisk = <span style={{ color: "red" }}>*</span>;

        return (
            <ul className="clinical_edit">
                {
                    DomConfig.map( item => {
                        const {
                            label,
                            name,
                            showName,
                            isRed,
                            type,
                            unit = '',
                            canEdit = true,
                            show = true,
                            isYseOrNo = false,
                            required = false,
                            typeProperty = {},
                            tipTitle = false,
                            canChange = false,
                            changeValue,
                            changeShow,
                        } = item;
                        const {
                            columns = [],
                            canDel = false,
                        } = typeProperty;
                        let Dom = '';
                        const value = params[name];
                        const markRed = (params[isRed] || false);
                        if(updateType === 'edit' && canEdit) {
                            Dom = this.nodeRender(item);
                        }else {
                            const value = showName ? params[showName] : params[name];
                            Dom = <span className='item-right_text'>{
                                    isYseOrNo ? 
                                        (value !== undefined && value !== null) ? 
                                            value == '1' ? '是' : 
                                                value == '0' ? '否' : 
                                            '' : 
                                        '' : 
                                    value
                                }</span>
                            if(type === 'Upload') {
                                const { fileList, downLoadFile } = typeProperty;
                                Dom = <div style={{ wordBreak: 'break-all', wordWrap: 'break-word' }}>
                                    {fileList.map(i => <a key={i.response.fileMetaId} onClick={e => downLoadFile(e, i.response.fileMetaId)}>{i.name}<br /></a>)}
                                </div>
                            }
                        }
                        if (type === 'RichText') {
                            const parseText = text => {
                                return (text || '')
                                  .replace(/<br\s*\/?>/gi, '\n')      // 替换 <br> 为换行符
                                  .replace(/&nbsp;/g, '\u00A0');     // 替换 &nbsp; 为 Unicode 空格
                            };
                            Dom = <div style={{ whiteSpace: 'pre-line' }}>{parseText(value)}</div>;
                        }
                        if(type === 'Table') {
                            const TableColumns = columns.map(tebleItem => {
                                const {
                                    tebleItemKey,
                                    showName,
                                    title,
                                    width,
                                    shouldRowSpan = false,
                                    className,
                                } = tebleItem;
                                return {
                                    title: title,
                                    key: tebleItemKey,
                                    dataIndex: tebleItemKey,
                                    width,
                                    className,
                                    render: (text, record, index) => {
                                        const { rowSpan } = record;
                                        let tebleDom = this.nodeRender({
                                            ...tebleItem,
                                            tebleItemKey,
                                            name,
                                            index,
                                            tebleIDate: text,
                                        }, true);
                                        const showText = updateType === 'edit' && canEdit ? tebleDom : <span>{showName ? record[showName] : text}</span>;
                                        return shouldRowSpan ? {
                                            props: { rowSpan },
                                            children: showText,
                                        } : showText;
                                    },
                                }
                            })
                            if(canDel && updateType === 'edit' && canEdit) {
                                TableColumns.push({
                                    title: '操作',
                                    key: 'operation',
                                    width: 120,
                                    render: (text, record, index) => {
                                        const { rowSpan } = record;
                                        const showText = <span>
                                            <a onClick={() => {
                                                this.MedicationSituationRef.show(index, value);
                                            }}>
                                                用药情况
                                            </a>
                                            <span className="ant-divider" />
                                            <a onClick={() => {
                                                if(value.length == 1) {
                                                    message.warning(`${label}最少有一条数据`)
                                                }else {
                                                    delTableRecord(name, index, rowSpan)
                                                }
                                            }}>删除</a>
                                        </span>
                                        return {
                                            props: { rowSpan },
                                            children: showText,
                                        }
                                    }
                                })
                            }
                            Dom = <TableC
                                // rowKey="rowId"
                                data={value}
                                columns={TableColumns}
                                pagination={false}
                                scrollY={200}
                            />
                        }
                        return show && (type === 'Title' ? <li className='clinical_edit_Titleitem'>{`${label} :`}</li> : <li  
                            key={name} 
                            className={ 
                                type === 'Table' ? "clinical_edit_Tableitem" : "clinical_edit_item"
                            }
                            style={style}
                            >
                            {
                                type !== 'Table' && <div className="item-left">
                                    <span className={(updateType === 'edit' && canChange) ? 'text-bg' : undefined}>
                                        {required && asterisk}{`${label} :`}
                                    </span>
                                </div>
                            }
                            <div className="item-right" style={{ color: markRed ? 'red' : undefined }}>
                                {Dom}
                                <span style={{ marginLeft: 10 }}>{unit}</span>
                                {
                                    tipTitle && <span style={{ marginLeft: 10 }}>
                                        <Tooltip overlayStyle={{ width: 160 }} placement="top" title={tipTitle}>
                                            <a><Icon style={{ marginLeft: 6, fontSize: '14px' }} type="info-circle-o" /></a>
                                        </Tooltip>
                                    </span>
                                }
                                {
                                    (updateType === 'edit' && canChange) && <span 
                                            style={{ cursor: 'pointer', margin: '0px 10px' }}
                                            onClick={() => this.refresh(changeValue, name, type)} 
                                        >
                                        <Tooltip overlayStyle={{ width: 160 }} placement="top" title={<span>{changeShow}</span>}>
                                            <Icon type="sync" style={{ fontSize: 14, fontWeight: 'bold', color: '#a6d5f8' }}/>
                                        </Tooltip>
                                    </span>
                                }
                            </div>
                        </li>)
                    })
                }
                <RouteModal 
                    handleTableChange={handleTableChange}
                    ref={el => this.RouteModalRef = el}
                />
                <MedicationSituation
                    handleTableChange={handleTableChange}
                    handleMedicationSituationChange={handleMedicationSituationChange}
                    ref={el => this.MedicationSituationRef = el}
                />
            </ul>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/clinicalEvaluation/clinicalEvaluationRecord/components/FomeList.js